import api from '@/apis/other/offlineVoucherAPI.js';
import Crud from '@/stores/crudBase.js';
var crud = new Crud('offlineVoucher', api);

const state = {
  ...crud.state,
  _config: {
    table: 'offline_voucher',
    field: {
      key: 'offline_voucher_id',
      code: 'ref_no',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
